import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

type CartReturnState = {callbackUrl?: string} | null;

function useCartReturn() {
  const {state} = useLocation();
  const navigate = useNavigate();
  const callbackUrl = (state as CartReturnState)?.callbackUrl;

  const goBackToCart = React.useCallback(() => {
    if (callbackUrl) {
      navigate(callbackUrl);
    }
  }, [callbackUrl, navigate]);

  return {isFromCart: Boolean(callbackUrl), goBackToCart};
}

export {useCartReturn};
